<template>
  <section id="manuslist-generator" class="content white large-padding scrollnav">
    <TheEmptyList :title="'Statistikk'" :message="'Velg type av statistikk i listan til venstre...'" :large="false" :icon="'button-glyph-spreadsheet'"/>
  </section>
</template>

<script>
export default {
  name: 'StatsEmpty'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Stats/StatsEmpty.vue